@if (field.sequentialView && isLanding) {
  <div class="common-text-input__container-field-sequential">
    <field-sequential-header [field]="field"></field-sequential-header>
    <label class="common-text-input__block-field-input-sequential"
      [ngClass]="{'common-text-input__block-field-input-sequential--error': field.error || field.errorInDateLock }"
      [attr.disabled]="field.noEditable?true:null"
      #containerFieldDate>
      <input-date class="common-text-input__container-input"
        [disabled]="field.noEditable"
        [input]="preSelectItem"
        [field]="field"
        (output)="outputDate($event)">
      </input-date>
      <div class="common-text-input__buttons-right-header">
        <div class="common-text-input__buttons-right-header-container">
          <button class="common-button__icon-sm-noborder"
            [disabled]="field.noEditable"
            (click)="toggleFilter($event, calendarFieldDateOverlay)">
            <i class="lf-icon-calendar common-icon__md"></i>
          </button>
          @if(!field.noEditable){
            <p-overlayPanel #calendarFieldDateOverlay
              styleClass="common-date__overlay-calendar"
              (onShow)="fieldTypeDate.openCalendar = true"
              (onHide)="fieldTypeDate.openCalendar = false">
              <ng-template pTemplate="content">
                @if (field.fromTo) {
                  <from-to-calendar [fromSave]="fieldTypeDate.creationDateFromDate"
                    [toSave]="fieldTypeDate.creationDateToDate"
                    (changeCalendar)="changeCalendar($event)"
                    [type]="'field-type-date'">
                  </from-to-calendar>
                }@else {
                  <p-calendar #calendarDate
                    class="common-date__calendar"
                    [(ngModel)]="preSelectItem"
                    [inline]="true"
                    [dateFormat]="'dd/mm/yy'"
                    [hourFormat]="'24'"
                    [firstDayOfWeek]="1"
                    [minDate]="fieldTypeDate.minDate"
                    [maxDate]="fieldTypeDate.maxDate"
                    (onSelect)="changeDatePicker($event)">
                    <ng-template pTemplate="previousicon">
                      <i class="lf-icon-angle-left common-icon__md common-icon__main"></i>
                    </ng-template>
                    <ng-template pTemplate="nexticon">
                      <i class="lf-icon-angle-right common-icon__md common-icon__main"></i>
                    </ng-template>
                  </p-calendar>
                }

              </ng-template>
            </p-overlayPanel>
          }
        </div>
        @if(field.showTime){
          <div class="common-text-input__buttons-right-header-container">
            <button class="common-button__icon-sm-noborder"
              type="button"
              [disabled]="field.noEditable"
              (click)="toggleFilter($event, clockFieldDateOverlay)">
              <i class="lf-icon-clock common-icon__md"></i>
            </button>
            @if(!field.noEditable){
              <p-overlayPanel #clockFieldDateOverlay
                styleClass="common-date__overlay-time"
                (onShow)="fieldTypeDate.openTime = true"
                (onHide)="fieldTypeDate.openTime = false">
                <ng-template pTemplate="content">
                  <time-picker ngbDropdownMenu
                    [hours]="fieldTypeDate.hours"
                    [minutes]="fieldTypeDate.minutes"
                    [field]="field"
                    (changeTime)="changeInTimePicker($event)">
                  </time-picker>
                </ng-template>
              </p-overlayPanel>
            }
          </div>
        }
      </div>
    </label>
    @if(field.error || field.errorInDateLock){
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        @if(field.errorInDateLock){
          <span>{{fieldTypeDate.errorText}}</span>
        }@else{
          <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
        }
      </div>
    }
  </div>
}@else {
  <div class="common-text-input__container"
    [id]="field.id">
    <div class="common-text-input__container-box"
      [ngClass]="{'common-text-input__container-box--focused': fieldTypeDate.openCalendar || fieldTypeDate.openTime,
        'common-text-input__container-box--error': field.error || field.errorInDateLock,
        'common-text-input__container-box-disabled': field.noEditable
      }"
      [attr.disabled]="field.noEditable?true:null"
      #containerFieldDate>
      <div class="common-text-input__block-header">
        <div class="common-text-input__label-no-cursor">
          <span class="common-text-input__text-label">{{fieldTypeDate.titleField}}</span>
          @if(field.required){
            <span class="common-tag__mandatory-text-asterisk">*</span>
          }
          <div class="common-text-input__block-buttons">
            @if (field.description) {
              <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
            }
            @if (field.references?.length) {
              <tooltip-law [references]="field.references"
              [field]="field"></tooltip-law>
            }
              @if (field.relatedInfo?.length){
                <button class="common-button__icon-sm-noborder"
                    type="button"
                    pTooltip="{{'common.related-info'| afTranslate}}"
                    tooltipPosition="top"
                    (click)="openModalRelatedInfo($event)">
                    <i class="lf-icon-search-text common-icon__md"></i>
                </button>
              }
              @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
                <tooltip-in-report [inReport]="fieldTypeDate.inReport"></tooltip-in-report>
              }
          </div>
        </div>
        <div class="common-text-input__buttons-right-header">
            @if (!isLanding && !public && field.showAlertButton && preSelectItem && !field.poll && !field.noEditable) {
              <button class="common-button__icon-sm-noborder"
                (click)="openAddAlert()">
                <i class="lf-icon-notification-new common-icon__md"></i>
              </button>
            }
            <div class="common-text-input__buttons-right-header-container">
              <button class="common-button__icon-sm-noborder"
                [disabled]="field.noEditable"
                (click)="toggleFilter($event, calendarFieldDateOverlay)">
                <i class="lf-icon-calendar common-icon__md"></i>
              </button>
              @if(!field.noEditable){
                <p-overlayPanel #calendarFieldDateOverlay
                  [styleClass]="field.fromTo?'common-dropdown-overlay__dates-container':'common-date__overlay-calendar'"
                  (onShow)="fieldTypeDate.openCalendar = true"
                  (onHide)="fieldTypeDate.openCalendar = false">
                  <ng-template pTemplate="content">
                    @if (field.fromTo) {
                      <from-to-calendar [fromSave]="fieldTypeDate.creationDateFromDate"
                        [toSave]="fieldTypeDate.creationDateToDate"
                        (changeCalendar)="changeCalendar($event)"
                        [type]="'field-type-date'">
                      </from-to-calendar>
                    }@else {
                      <p-calendar #calendarDate
                        class="common-date__calendar"
                        [(ngModel)]="preSelectItem"
                        [inline]="true"
                        [dateFormat]="'dd/mm/yy'"
                        [hourFormat]="'24'"
                        [firstDayOfWeek]="1"
                        [minDate]="fieldTypeDate.minDate"
                        [maxDate]="fieldTypeDate.maxDate"
                        (onSelect)="changeDatePicker($event)">
                        <ng-template pTemplate="previousicon">
                          <i class="lf-icon-angle-left common-icon__md common-icon__main"></i>
                        </ng-template>
                        <ng-template pTemplate="nexticon">
                          <i class="lf-icon-angle-right common-icon__md common-icon__main"></i>
                        </ng-template>
                      </p-calendar>
                    }

                  </ng-template>
                </p-overlayPanel>
              }
            </div>
            @if(field.showTime){
              <div class="common-text-input__buttons-right-header-container">
                <button class="common-button__icon-sm-noborder"
                  type="button"
                  [disabled]="field.noEditable"
                  (click)="toggleFilter($event, clockFieldDateOverlay)">
                  <i class="lf-icon-clock common-icon__md"></i>
                </button>
                @if(!field.noEditable){
                  <p-overlayPanel #clockFieldDateOverlay
                    styleClass="common-date__overlay-time"
                    (onShow)="fieldTypeDate.openTime = true"
                    (onHide)="fieldTypeDate.openTime = false">
                    <ng-template pTemplate="content">
                      <time-picker ngbDropdownMenu
                        [hours]="fieldTypeDate.hours"
                        [minutes]="fieldTypeDate.minutes"
                        [field]="field"
                        (changeTime)="changeInTimePicker($event)">
                      </time-picker>
                    </ng-template>
                  </p-overlayPanel>
                }
              </div>
            }
        </div>
      </div>
      <div class="common-text-input__block-input"
      [ngClass]="{'common-text-input__block-input--with-value': preSelectItem && !field.noEditable }">
        @if (field.fromTo){
          <p class="common-text-input__container-input">{{preSelectItem}}</p>
        }@else if(!field.noEditable || preSelectItem){
          <input-date class="common-text-input__container-input"
              [disabled]="field.noEditable"
              [input]="preSelectItem"
              [field]="field"
              (output)="outputDate($event)">
          </input-date>
        }
        @if (preSelectItem && !field.noEditable){
          <button class="common-text-input__icon-clean-input"
              type="button"
              (click)="deleteValueField()">
              <i class="lf-icon-close-thick common-icon__sm"></i>
          </button>
        }
      </div>
    </div>
    @if(field.error || field.errorInDateLock){
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        @if(field.errorInDateLock){
          <span>{{fieldTypeDate.errorText}}</span>
        }@else{
          <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
        }
      </div>
    }
  </div>
}
